module.exports = __webpack_public_path__ + "media/components/Bazaarvoice/icons/chevron-down-842fe736efcc2f702019f081f9d17bd6.svg";